'use client'

import posthog from 'posthog-js'

// Track in production only — keeps local dev (and a developer's clicks) out of
// real analytics. PostHogProvider gates init() on this same flag, so capture
// calls outside production would hit an uninitialized client anyway.
export const ANALYTICS_ENABLED =
  !!process.env.NEXT_PUBLIC_POSTHOG_KEY && process.env.NODE_ENV === 'production'

/**
 * Fire-and-forget product event. Call from the store action that represents the
 * user's intent (one event per intent, not per render or per retry) — posthog-js
 * batches and survives offline, so no awaiting needed.
 */
export function track(event: string, properties?: Record<string, unknown>) {
  if (!ANALYTICS_ENABLED) return
  posthog.capture(event, properties)
}
